import React, { FC } from 'react';
import Box from '@material-ui/core/Box';

import { DownloadFile } from '@keaze/web/components/downloadFile';
import { Title } from './groupDownloadFile.styles';
import { GroupDownloadFileProps } from './groupDownloadFile.types';

export const GroupDownloadFile: FC<GroupDownloadFileProps> = ({
  title,
  data,
  ...rest
}) => (
  <Box {...rest}>
    <Title variant="h2">{title}</Title>
    <DownloadFile data={data} />
  </Box>
);
